import React, { ReactNode } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import MainLayout from '../layouts/MainLayout'
import Spinner from '../components/loader.gif'
import {
  LOGIN_ROUTE,
  ALL_TRAINIGS_PAGE_ROUTE,
  MY_TRAINIGS_PAGE_ROUTE,
  FINISHED_TRAINIGS_PAGE_ROUTE,
  REPORTS,
  BOOKED_TRAININGS_ROUTE
} from '../routes'
import { NavWrapper } from '../ui-components/NavBar'
import { ModalProvider } from '../contexts/modalContext'
import { useAuth } from '../graphql/hooks/useAuth'

const LoginPage = React.lazy(() =>
  import('./LoginPage').then((m) => ({ default: m.LoginPage })),
)
const AllTrainings = React.lazy(() =>
  import('./AllTrainigs').then((m) => ({ default: m.AllTrainigs })),
)
const MyTrainings = React.lazy(() =>
  import('./MyTrainigs').then((m) => ({ default: m.MyTrainigs })),
)
const Bookedrainings = React.lazy(() =>
  import('./BookedTrainings').then((m) => ({ default: m.Bookedrainings })),
)
const FinishedTrainings = React.lazy(() =>
  import('./FinishedTrainings').then((m) => ({ default: m.FinishedTrainigs })),
)
const Reports = React.lazy(() =>
  import('./Reports').then((m) => ({ default: m.Reports })),
)

const RequireAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { token } = useAuth()
  if (!token) return <Navigate to={LOGIN_ROUTE} replace />
  return <>{children}</>
}

const RedirectIfAuthed: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { token } = useAuth()
  if (token) return <Navigate to={ALL_TRAINIGS_PAGE_ROUTE} replace />
  return <>{children}</>
}

const HomeRedirect: React.FC = () => {
  const { token } = useAuth()
  return <Navigate to={token ? ALL_TRAINIGS_PAGE_ROUTE : LOGIN_ROUTE} replace />
}

const Pages: React.FC = () => {
  return (
    <NavWrapper>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />

        <Route
          path={LOGIN_ROUTE}
          element={
            <RedirectIfAuthed>
              <React.Suspense fallback={<SpinnerComponent />}>
                <LoginPage />
              </React.Suspense>
            </RedirectIfAuthed>
          }
        />

        <Route
          path={ALL_TRAINIGS_PAGE_ROUTE}
          element={
            <RequireAuth>
              <MainLayout>
                <React.Suspense fallback={<SpinnerComponent />}>
                  <AllTrainings />
                </React.Suspense>
              </MainLayout>
            </RequireAuth>
          }
        />

        <Route
          path={MY_TRAINIGS_PAGE_ROUTE}
          element={
            <RequireAuth>
              <MainLayout>
                <React.Suspense fallback={<SpinnerComponent />}>
                  <Providers>
                    <MyTrainings />
                  </Providers>
                </React.Suspense>
              </MainLayout>
            </RequireAuth>
          }
        />

        <Route
          path={BOOKED_TRAININGS_ROUTE}
          element={
            <RequireAuth>
              <MainLayout>
                <React.Suspense fallback={<SpinnerComponent />}>
                  <Providers>
                    <Bookedrainings />
                  </Providers>
                </React.Suspense>
              </MainLayout>
            </RequireAuth>
          }
        />

        <Route
          path={FINISHED_TRAINIGS_PAGE_ROUTE}
          element={
            <RequireAuth>
              <MainLayout>
                <React.Suspense fallback={<SpinnerComponent />}>
                  <FinishedTrainings />
                </React.Suspense>
              </MainLayout>
            </RequireAuth>
          }
        />

        <Route
          path={REPORTS}
          element={
            <RequireAuth>
              <MainLayout>
                <React.Suspense fallback={<SpinnerComponent />}>
                  <Reports />
                </React.Suspense>
              </MainLayout>
            </RequireAuth>
          }
        />

        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </NavWrapper>
  )
}

const Providers: React.FC<{ children: ReactNode }> = ({ children }) => (
  <ModalProvider>{children}</ModalProvider>
)

const SpinnerComponent = () => (
  <div className="h-screen w-screen bg-white z-20 absolute flex items-center justify-center">
    <div className="flex items-center justify-center flex-wrap max-w-48">
      <img className="flex w-24" src={Spinner} alt="" />
      <br />
      <div className="w-full text-center mx-auto flex justify-center font-body mt-6 text-base text-blue-400 leading-5">
        {'Daten werden geladen.'}
      </div>
    </div>
  </div>
)

export default Pages
